import { css } from '@emotion/react';
import t from 'react-translate';
import prodPathReplace from 'shared/prod-path-rewrite';
import { quarterSpacing } from 'styles/global_defaults/scaffolding';


const NoGuides = () => {
  const styles = css`
    height: 300px;

    img {
      height: 80px;
      width: 80px;
      margin-bottom: ${quarterSpacing}px;
    }
  `;

  return (
    <div css={styles} className='d-flex flex-column justify-content-center align-items-center bg-gray-7'>
      <img src={prodPathReplace('images/no-guides.svg')} alt='' />
      <span className='gray-2'>{t.MENTORING_PROGRAMS.GUIDANCE.GUIDES.NO_GUIDES()}</span>
    </div>
  );
};

export default NoGuides;
